"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _nl_NL = _interopRequireDefault(require("../../date-picker/locale/nl_NL"));
var _default = _nl_NL["default"];
exports["default"] = _default;